import React from 'react';
import AdminDashboard from '../AdminDashboard';

const WebhooksPage = () => <AdminDashboard forcedTab="webhooks" embedded />;

export default WebhooksPage;
